export const MAX_LOAN_THRESHOLD = 350000
export const LOAN_MODIFICATION_FEE = 250
export const MAX_APPLICANT_INCOME_FOR_INCENTIVE = 163900

// CCEF Platform Link
export const CCEF_PLATFORM_LINK = "https://partner.cleanenergy.finance/forms/loan-application-contractor/68d374132f3240eb42fc02b7/690acbd102094169cbc27e8c"
export const CCEF_INSTALLER_APPLICATION_LINK = "https://partner.cleanenergy.finance/forms/contractor-application/org_nHBNiMvUyGm72n2b"
export const CCEF_APPLICATION_REFERRAL_SOURCE = 'CCEF'
export const CCEF_PLATFORM_LOAN_AMOUNT_THRESHOLD = 75_000

// Fund Realease 
export const FUND_RELEASE_SUPPORT_LINK = "https://oneethos.com/support/fund-release"
export const FUND_RELEASE_LOAN_HELP_LINK = "https://www.climatefirstbank.com/solar-loan-funding-help"
export const TEST_APP_ID = 9_999_999
export const TEST_PHONE_NUMBER = '9991234567'
export const TEST_PHONE_MFA_CODE = '1111'
export const FUNDS_RELEASE_EXPIRES_SECONDS = 168 * 60 * 60 //  7 days in seconds 
export const FUND_RELEASE_RESEND_WAIT_TIME_SECONDS = 10 * 60  // 10 minutes in seconds

// Consumer protection
export const SOLAR_DEALER_FEES_LINK = "https://www.climatefirstbank.com/cfb-blog/what-are-solar-dealer-fees-and-why-should-i-care"
export const CONSUMER_PROTECTION_RECOMMENDATION_LINK = "https://uploads-ssl.webflow.com/635ae89b651fdf01ef0360a7/662137a89e5f67918b9482b6_IB-Rooftop-Solar-Consumer-Protection-Recommendations.pdf"
export const HOW_TO_SPOT_SOLAR_PANEL_SCAMS_LINK = "https://www.climatefirstbank.com/cfb-blog/what-your-solar-company-should-and-shouldnt-be-doing"
export const ROOFTOP_SOLAR_ENERGY_CONTRACT_LINK = "https://www.energy.gov/eere/solar/articles/where-do-i-sign-understanding-your-rooftop-solar-energy-contract"
export const NEVER_SIGN_A_SOLAR_LOAN_BEFORE_CHECKING_THIS = "https://www.youtube.com/watch?v=lT6Zfff7pyc"
export const HELP_CENTER_LINK = "https://intercom.help/oneethos/en/"
export const APR_EXPLANATION_LINK = "https://www.oneethos.com/apr-explained"
export const AVL_LINK = "https://oneethos.com/AVL"
export const ONEETHOS_SOLAR_FAQ_LINK = "https://www.oneethos.com/solar-faq"

// Review Terms
export const TERMS_AND_CONDITIONS_URL = "https://uploads-ssl.webflow.com/635ae89b651fdf01ef0360a7/63fd1bb51695e86a2e73a542_FINAL-Terms-and-Conditions-Climate-First_Accessible.pdf"
export const PRIVACY_POLICY_URL = "https://uploads-ssl.webflow.com/635ae89b651fdf01ef0360a7/63fd1b125c945e62586bc929_FINAL-Privacy-Policy-Accessible.pdf"
export const ESIGN_AGREEMENT_URL = "https://uploads-ssl.webflow.com/635ae89b651fdf01ef0360a7/63fd34e2f8e1cd8416c96c95_6251ac8b953d1e2a1dfee967_eSign.pdf"

export const COMMUNITY_PROPERTY_STATES = [
  "AZ",
  "CA",
  "ID",
  "LA",
  "NV",
  "NM",
  "TX",
  "WA",
  "WI",
]

export const BANK_CALL_LINK = "https://www.climatefirstbank.com/call"
export const BANK_PHONE_NUMBER = "(727) 335-0508"
